/**
 * Parser para arquivos OFX (Open Financial Exchange)
 * Extrai transações de extratos bancários
 */

export interface OFXTransaction {
  data: string;
  descricao: string;
  valor: number;
  tipo: 'recebimento' | 'pagamento';
}

export function parseOFX(conteudo: string): OFXTransaction[] {
  const transacoes: OFXTransaction[] = [];

  // Remove espaços em branco extras e converte para maiúsculas
  const texto = conteudo.replace(/\r\n/g, '\n');

  // Encontra todas as transações (STMTTRN)
  const regex = /<STMTTRN>.*?<\/STMTTRN>/gs;
  const matches = texto.match(regex) || [];

  matches.forEach((match) => {
    try {
      const transacao = parseTransacao(match);
      if (transacao) {
        transacoes.push(transacao);
      }
    } catch (erro) {
      console.warn('Erro ao parsear transação OFX:', erro);
    }
  });

  // Ordena por data crescente
  transacoes.sort((a, b) => new Date(a.data).getTime() - new Date(b.data).getTime());

  return transacoes;
}

function parseTransacao(texto: string): OFXTransaction | null {
  try {
    // Extrair data (DTPOSTED)
    const dataMatch = texto.match(/<DTPOSTED>(\d{8})/);
    if (!dataMatch) return null;

    const dataStr = dataMatch[1];
    const ano = parseInt(dataStr.substring(0, 4));
    const mes = parseInt(dataStr.substring(4, 6));
    const dia = parseInt(dataStr.substring(6, 8));
    const data = `${ano}-${String(mes).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;

    // Extrair valor (TRNAMT)
    const valorMatch = texto.match(/<TRNAMT>(-?\d+\.?\d*)/);
    if (!valorMatch) return null;

    const valor = Math.abs(parseFloat(valorMatch[1]));
    const tipo = parseFloat(valorMatch[1]) >= 0 ? 'recebimento' : 'pagamento';

    // Extrair descrição (MEMO ou NAME)
    let descricao = 'Transação';
    const memoMatch = texto.match(/<MEMO>([^<]+)/);
    const nameMatch = texto.match(/<NAME>([^<]+)/);

    if (memoMatch) {
      descricao = memoMatch[1].trim();
    } else if (nameMatch) {
      descricao = nameMatch[1].trim();
    }

    return {
      data,
      descricao,
      valor,
      tipo,
    };
  } catch (erro) {
    console.warn('Erro ao processar transação:', erro);
    return null;
  }
}

/**
 * Valida um arquivo OFX
 */
export function isValidOFX(conteudo: string): boolean {
  return conteudo.includes('<OFX>') || conteudo.includes('<ofx>');
}
